/** Public Awin programme identifier, overridable per frontend environment. */
export const AWIN_ADVERTISER_ID = String(import.meta.env.VITE_AWIN_ADVERTISER_ID || '129203');
